import { apiCall } from "./service";
import {
  URL_SHIFTS,
  URL_CREATE_SHIFT,
  URL_UPDATE_SHIFT,
  URL_DELETE_SHIFT,
  URL_SHIFT_DETAILS,
  URL_ASSIGN_SHIFT,
  URL_SHIFT_FLAG
} from "./URL";

export const api = {  

  getShiftsRequest(params) {
    const { search, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    
    if (search) {
      paginationParams.searchTerm = search;
    }
  
    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${URL_SHIFTS}?${queryParams}`;
  
    return apiCall.pagination({ url: fullUrl });
  },

  fetchSingleShiftRequest(id) {
    return apiCall.get({url: `${URL_SHIFT_DETAILS}${id}`});
  },
  
  createShiftRequest(params) {
    return apiCall.post({url: `${URL_CREATE_SHIFT}`, isAuthToken: true, params: params.payload });
  },
  
  updateShiftRequest(params) {
    return apiCall.put({url: `${URL_UPDATE_SHIFT}${params.id}`, isAuthToken: true, params: params.payload });
  },
  
  deleteShiftRequest(params) {
    return apiCall.delete({url: `${URL_DELETE_SHIFT}${params.id}`, isAuthToken: true, params });
  }, 

  sortShiftsRequest(params) {
    return apiCall.pagination({url: `${URL_SHIFTS}?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`, isAuthToken: true });
  },

  assignShiftRequest(params) {
    return apiCall.put({url: `${URL_ASSIGN_SHIFT}`, isAuthToken: true, params: params.payload });
  },
  updateShiftFlagRequest(params) {
    return apiCall.patch({url: `${URL_SHIFT_FLAG}${params.id}`, isAuthToken: true, params: params.payload });
  },
  
};

export default api;
